// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ho-z","breadcrumbForward":"Io-z","breadcrumbBack":"Jo-z","selected":"Ko-z"};